import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestTokensDelete } from '@shared/common/_requests/request_tokens_delete';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { update_search_locally } from '../_methods/update_search_locally';
import { StateSearch } from '../state_search';

export const remote_search_tokens_delete = createAsyncThunkSafe<void, RequestTokensDelete>(
  ENUM__network_event_client_to_server.SEARCH_TOKENS_DELETE,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.SEARCH_TOKENS_DELETE, request);
  },
);

export function init_remote_search_tokens_delete(builder: ActionReducerMapBuilder<StateSearch>) {
  builder
    .addCase(remote_search_tokens_delete.pending, (state, action) => {
      let request: RequestTokensDelete = action.meta.arg;
      let search_id = request.entity_id;

      let search = state.search_history_map.get_or_assert(search_id, { context: 'search' });

      //for other statuses new generation will be created

      let tokens_new = search.tokens.filter(token => !request.words_english.includes(token.word_english));

      search = search.clone({ tokens: tokens_new });

      update_search_locally(state, search);
    })
    .addCase(remote_search_tokens_delete.rejected, (state, action) => {})
    .addCase(remote_search_tokens_delete.fulfilled, (state, action: PayloadAction) => {});
}
